// Mock data for role dropdown (excludes Super Admin=1, Admin=2, Patient=6)
export const mockRoleDropdownResponse = {
  rescode: 1,
  data: {
    roles: [
      { RoleId: 3, RoleName: "Reception", IsActive: 1, IsDeleted: 0, clinic_id: null },
      { RoleId: 4, RoleName: "Accountant", IsActive: 1, IsDeleted: 0, clinic_id: null },
      { RoleId: 5, RoleName: "Employee", IsActive: 1, IsDeleted: 0, clinic_id: null },
      { RoleId: 7, RoleName: "Senior Therapist", IsActive: 1, IsDeleted: 0, clinic_id: 1 },
      { RoleId: 8, RoleName: "Junior Therapist", IsActive: 1, IsDeleted: 0, clinic_id: 1 },
      { RoleId: 9, RoleName: "Intern / Trainee", IsActive: 1, IsDeleted: 0, clinic_id: 1 },
      { RoleId: 10, RoleName: "Clinic Manager", IsActive: 1, IsDeleted: 0, clinic_id: 1 },
    ],
  },
};
